<template>
  <v-dialog
    :value="value"
    persistent
    :max-width="!goToTimingInput ? '600px' : '820px'"
  >
    <v-card>
      <v-card-title class="pb-2">
        <span class="headline">
          センサー{{ title }}
        </span>
      </v-card-title>
      <v-divider />
      <component
        :is="content"
        v-if="value"
        :from="from ? from.serialNo : null"
        :to="to ? to.serialNo : null"
        :serial-regex="serialRegex"
        :operation="title"
        :sensor-installed-at="from ? from.sensorInstalledAt : null"
        @setTo="setTo($event)"
        @updateTimestamp="timestamp = $event"
      />
      <v-card-actions>
        <v-spacer />
        <div class="btn-wrapper">
          <v-btn
            color="warning"
            @click="clear"
          >
            キャンセル
          </v-btn>
          <v-btn
            v-if="!goToTimingInput"
            ref="proceedBtn"
            color="success"
            :disabled="!to"
            @click="pre = false"
          >
            次へ
          </v-btn>
          <v-btn
            v-else
            :color="isSensorRemoval ? 'red' : 'success'"
            :loading="loading"
            :dark="!!timestamp"
            :disabled="!timestamp"
            @click="register"
          >
            {{ title }}
          </v-btn>

          <div
            v-if="errorMessage"
            class="error-message"
          >
            {{ errorMessage }}
          </div>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapMutations } from 'vuex'
export default {
  name: 'SensorEditDialog',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    customerId: {
      type: Number,
      default: () => null
    },
    tankId: {
      type: Number,
      default: () => null
    },
    from: {
      type: Object,
      default: () => null
    },
    isSensorRemoval: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      pre: true,
      to: null,
      timestamp: null,
      serialRegex: /[A-Z]{3}-\d{4}$/,
      loading: false,
      errorMessage: ''
    }
  },
  computed: {
    title () {
      return this.isSensorRemoval ? '撤去'
        : this.from ? '交換'
          : '設置'
    },
    goToTimingInput () {
      return !this.pre || this.isSensorRemoval
    },
    content () {
      return this.goToTimingInput
        ? () => import('./SensorEditDialog/TimingInput')
        : () => import('./SensorEditDialog/SerialInput')
    }
  },
  methods: {
    ...mapMutations('app', ['setGlobalSnackBarText']),
    ...mapActions('customers', ['updateSensor']),
    clear () {
      this.pre = true
      this.to = null
      this.loading = false
      this.errorMessage = ''
      this.$emit('toggleDialog')
    },
    setTo (sensorInfo) {
      this.to = sensorInfo
      if (sensorInfo) this.$nextTick(() => this.$refs.proceedBtn.$el.focus())
    },
    async register () {
      this.loading = true
      this.errorMessage = ''

      const body = {
        timestamp: this.timestamp
      }
      const serial = {
        from: null,
        to: null
      }
      if (this.from) {
        body.replaceFrom = this.from.id
        serial.from = this.from.serialNo
      }
      if (this.to) {
        body.replaceTo = this.to.id
        serial.to = this.to.serialNo
      }

      try {
        const message = await this.updateSensor({ body, customerId: this.customerId, tankId: this.tankId, serial })

        this.setGlobalSnackBarText(message)
        this.$emit('update-sensor-info', { serialNo: serial.to, id: body.replaceTo })

        this.clear()

        // after sensorReplace, info. such as sensorInstalledTimestamp of tank is not getting updated. So "force refresh" after the sensorReplace.
        this.$store.dispatch('customers/search')
      } catch (err) {
        this.errorMessage =
          err.response?.body?.errorMessage ||
          `エラーにより${this.title}できませんでした。`

        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-wrapper {
  position: relative;
  width: 240px;
  display: flex;
  justify-content: flex-end;
}
.error-message {
  position: absolute;
  bottom: 45px;
  right: 2px;
  max-width: 100%;
  color: red;
  font-size: 0.8rem;
  font-weight: bold;
  pointer-events: none;
}
</style>
